import { Colors, Text } from '@factorialco/deprecated-design-system'
import {
  AttendanceEditTimesheetRequestRequestTypeEnum,
  TimesheetEditTimesheetRequestFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const renderChange = (
  field: string,
  color: Colors,
  originalValue?: string | null,
  newValue?: string | null
) => {
  if (newValue && newValue !== originalValue) {
    return (
      <li key={field} style={{ listStyleType: 'disc' }}>
        <Text.Normal color={color} weight="medium">
          {`${field}:`}&nbsp;
        </Text.Normal>
        {originalValue && (
          <>
            <Text.Normal color={color} stroked>
              {originalValue}
            </Text.Normal>
            <Text.Normal color={color}>{'->'}</Text.Normal>
          </>
        )}
        <Text.Normal weight="bold" color={color}>
          {newValue}
        </Text.Normal>
      </li>
    )
  }
}

const modalTextByType = (
  requestType: AttendanceEditTimesheetRequestRequestTypeEnum
): { title: string; description: string } => {
  if (requestType === 'create_shift') {
    return {
      title: i18n.t('clock_in.edit_timesheet_requests.modal.create_shift.title'),
      description: i18n.t('clock_in.edit_timesheet_requests.modal.create_shift.description'),
    }
  }
  if (requestType === 'delete_shift') {
    return {
      title: i18n.t('clock_in.edit_timesheet_requests.modal.delete_shift.title'),
      description: i18n.t('clock_in.edit_timesheet_requests.modal.delete_shift.description'),
    }
  }
  return {
    title: i18n.t('clock_in.edit_timesheet_requests.modal.edit_shift.title'),
    description: i18n.t('clock_in.edit_timesheet_requests.modal.edit_shift.description'),
  }
}

const modalTextByRequest = (
  request: TimesheetEditTimesheetRequestFragment
): { title: string; description: string } => {
  return modalTextByType(request.requestType)
}

export { renderChange, modalTextByRequest, modalTextByType }
